$('.delivery-block').on('click', function (e) {
    e.preventDefault();
    let text = 'Eine oder mehrere Lieferpositionen sind für die Faktura gesperrt.';
    showPrintSweetAlert(text);
});

function showPrintSweetAlert(text) {
    Swal.fire({
        title: 'Rechnungserstellung gesperrt',
        icon: 'warning',
        text: 'Eine Rechnung kann aus diesem Auftrag nicht erstellt werden. ' + text,
        showConfirmButton: false,
        showCancelButton: false,
    });
}
